var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoccer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Soccer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Soccer",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sporticon/soccer",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0145039,0 C24.2234612,0 27.4771507,0.738305532 30.5304904,2.29203168 C40.8621568,7.55694228 44.9720582,20.199868 39.7071002,30.5297612 C35.9974783,37.8112985 28.6273771,42 20.9817423,42 C17.7744651,42 14.5207756,41.2633325 11.467436,39.7079683 C1.13581157,34.4426377 -2.97077171,21.799712 2.29250627,11.4714989 C6.00044802,4.19197768 13.3722294,0 21.0145039,0 Z M21.0142981,3.2225075 C20.3104276,3.2225075 19.6131095,3.26352634 18.9191094,3.34555982 L18.9191094,3.34555982 L14.4563907,8.1774331 L7.92969078,8.94854194 C6.83696522,10.1347534 5.90338546,11.4735569 5.15852095,12.9321493 C4.41361444,14.3956138 3.87876442,15.9313213 3.5621067,17.5162126 L3.5621067,17.5162126 L6.77954841,23.2553222 L5.49487344,29.7046802 C6.03955613,30.6776071 6.67286318,31.5947558 7.39643264,32.4561262 C8.77636828,34.0951578 10.423605,35.4536601 12.300593,36.5069783 L12.300593,36.5069783 L18.7453889,35.2206768 L24.47951,38.4380895 C26.4761619,38.0344534 28.4006962,37.2945098 30.1628086,36.2379155 C31.2030315,35.6112084 32.171011,34.8860074 33.0537263,34.073863 L33.0537263,34.073863 L33.8248421,27.5438618 L38.6601191,23.0778231 C38.691293,22.8103564 38.7159045,22.5445866 38.7354288,22.2728315 C38.8994888,19.9807998 38.618915,17.7049808 37.903578,15.509721 C37.6870154,14.8484885 37.4359691,14.2020827 37.1472049,13.5769717 L37.1472049,13.5769717 L31.1866927,10.8288018 L28.438498,4.85826293 C27.357239,4.36113105 26.23339,3.97229629 25.0865237,3.6999406 C23.7542604,3.38329413 22.3859174,3.2225075 21.0142981,3.2225075 Z M17.5984765,14.7694708 L25.9134981,16.0867695 L27.2309766,24.400162 L19.729829,28.2213489 L13.7756171,22.2722309 L17.5984765,14.7694708 Z",
    id: "Combined-Shape-Copy-2"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccer);
export default ForwardRef;